import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { accountQuery, cmsPagesQuery } from '@/api';
import { topInfoTickerFromPages, type TopInfoTickerContent } from '@/domain';
import { useTranslations } from '@/i18n/TranslationsProvider';

/** Active TopInfo CMS ticker content, or null when none. */
export function useTopInfoTicker(): TopInfoTickerContent | null {
  const { data: account } = useQuery(accountQuery());
  const { selectedLanguage } = useTranslations();
  const accountGuid = account?.Guid ?? '';

  const { data } = useQuery({
    ...cmsPagesQuery(accountGuid, selectedLanguage),
    enabled: Boolean(accountGuid && selectedLanguage),
  });

  return useMemo(() => {
    if (!accountGuid || !data?.Data) return null;
    return topInfoTickerFromPages(data.Data);
  }, [accountGuid, data]);
}
